import dynamic from "next/dynamic";
import { useState } from "react";
import { CloudinaryImage } from "../../Atoms/Cloudinary";
import styles from "./styles.module.scss";

// Loaded on demand so Apollo (used by its mutation) stays out of the shared layout bundle.
const EbookModal = dynamic(() => import("./EbookModal"), { ssr: false });

export default function EbookBanner() {
  const [isOpen, setIsOpen] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);
  const openModal = () => {
    setHasOpened(true);
    setIsOpen(true);
  };

  return (
    <>
      <div className={styles.EbookBanner} data-footer-ebook>
        <div className={styles.EbookBannerImage}>
          <CloudinaryImage
            src="https://res.cloudinary.com/dbm1qiew0/image/upload/v1773114480/ebook/ebook_foot.png"
            transformations={{
              mobile: ["w_360", "c_scale"],
              tablet: ["w_400", "c_scale"],
              web: ["w_425", "c_scale"],
            }}
          />
        </div>

        <div>
          <h4>Download Our Local Guides' Favorite Eats in Japan</h4>
          <p>
            Don't Guess Where to Eat — Download This.
            <br />
            Local guides share 60 spots they actually love.
          </p>

          <button onClick={openModal}>Download For Free</button>
        </div>
      </div>

      {/* Mounted on first open, so the modal's chunk (with Apollo) isn't fetched with the page. */}
      {hasOpened && (
        <EbookModal open={isOpen} onClose={() => setIsOpen(false)} />
      )}
    </>
  );
}
